import { Component, Input } from '@angular/core';
import { Json2csvService } from "../../../services/json2csv.service";
import { CommonHelper } from "../../../shared/helpers/CommonHelper";
import { UtilsProjectCost } from '../utils';

@Component({
  selector: 'app-project-cost-listing',
  templateUrl: './project-cost-listing.component.html',
  styleUrls: ['./project-cost-listing.component.css']
})
export class ProjectCostListingComponent {
  @Input() projections: any;
  @Input() currentPage: number;
  @Input() totalItems: number;
  @Input() limit: number;
  commonHelper: CommonHelper = new CommonHelper();

  constructor(
    private Json2csvService: Json2csvService,
    private utilsProjectCost: UtilsProjectCost
  ) { }

  async export(index) {
    let projection = this.projections[index];
    let newCSV = [];

    projection.consultants.map((consultant) => {
      consultant.competences.map(date => {
        let newDate = this.utilsProjectCost.multiSelectMonthsAndYears(`${date.month}/${date.year}`);
        newCSV.push({
          "Consultores":          consultant.name ? consultant.name : '-',
          "Tipo de Contrato":     consultant.kind ? this.commonHelper.transcriptContractType(consultant.kind) : '-',
          "Honorario":            consultant.honorarium ? this.commonHelper.transcriptHonorariumType(consultant.honorarium) : '-',
          "Cliente":              projection.customer.name ? projection.customer.name : '-',
          "Grupo de Empresa":     projection.companyGroup.name ? projection.companyGroup.name : '-',
          "Projeto":              projection.project.name ? projection.project.name : '-',
          "Tipos de Serviços":    projection.project.subDivision ? projection.project.subDivision.name ? projection.project.subDivision.name : '-' : '-',
          "Horas Estimadas":      consultant.estimatedHours ? consultant.estimatedHours : '-',
          "Valor Total Hora":     consultant.hourValue ? consultant.hourValue.toLocaleString("pt-BR",{maximumSignificantDigits : 4}) : '-',
          "Competência":          newDate && newDate.name ? newDate.name.slice(0, -5) : '-',
          "Ano":                  newDate && newDate.name ? newDate.name.slice(-4) : '-',
          "Projeção de Custos":   consultant.projectCost ? consultant.projectCost.toLocaleString("pt-BR",{maximumSignificantDigits : 6}) : '-',
        });
      });
    });
    this.Json2csvService.export(newCSV, `Projeção ${projection.project.name } - ${new Date().toLocaleDateString('pt-br')}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/project-cost/project-cost-listing/project-cost-listing.component.ts